import { HeaderContainer } from "../../components/Layout/HeaderContainer/HeaderContainer";
import { PageContainer } from "../../components/Layout/PageContainer/PageContainer";

import { DebugContent } from "../../components/Pages/Debug/Main/DebugContent/DebugContent";
import { AccessHeaderLogo } from "../../components/Shared/Buttons/AccessHeaderLogo";
import { MenuButton } from "../../components/Shared/Buttons/MenuButton";
import { PageTitle } from "../../components/Shared/Headings/PageTitle";

export function DebugPage() {
  return (
    <PageContainer
      header={{
        content: (
          <HeaderContainer
            start={<MenuButton />}
            middle={<PageTitle title="Debug" />}
            end={<AccessHeaderLogo />}
          />
        )
      }}
      main={{
        content: <DebugContent />
      }}
    />
  );
}
